import { AutomationService } from '@/services/automations.service'
import { AutomationFilters } from '@/types/filters/automation'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'

export const listAutomationsQuery = (filters?: AutomationFilters) =>
  queryOptions({
    queryKey: ['list-automations', filters],
    queryFn: () => AutomationService.list(filters),
    placeholderData: keepPreviousData,
  })
